'use client';

import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import useScrollTracking from '@/app/hooks/useScrollTracking';

import WhyOuraAccolades from './_components/WhyOuraAccolades';
import WhyOuraAccuracy from './_components/WhyOuraAccuracy';
import WhyOuraDesign from './_components/WhyOuraDesign';
import WhyOuraExplore from './_components/WhyOuraExplore';
import WhyOuraHero from './_components/WhyOuraHero';
import WhyOuraPersonalInsights from './_components/WhyOuraPersonalInsights';
import WhyOuraResearch from './_components/WhyOuraResearch';
import WhyOuraWellness from './_components/WhyOuraWellness';
import { whyOuraGradients } from './_data/whyOuraGradients';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();
  return (
    <RadialGradientBG background="sandstone-200" gradients={whyOuraGradients}>
      <WhyOuraHero />
      <WhyOuraWellness />
      <WhyOuraResearch />
      <WhyOuraAccuracy />
      <WhyOuraDesign />
      <WhyOuraPersonalInsights />
      <WhyOuraAccolades />
      <WhyOuraExplore />
    </RadialGradientBG>
  );
};

export default Content;
